// Countries Getters

export const getFullCountriesListEn = state => {
  return state.fullCountriesListEn
}

export const getFullCountriesListAr = state => {
  return state.fullCountriesListAr
}
